import React from 'react';

import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';
import MinimumPriceMessage from '../../../../components/minimum-price-message/minimum-price-message';
import Price from '../../../../components/price/price';
import StackedMarkdownPrice from '../../../../components/stacked-markdown-price/stacked-markdown-price';

import { useFitment, useMyAccount } from '../../../../shared/hooks/hooks';

import {
  getMapProductInstantSavingsInfo,
  getPriceInfo,
  getShouldShowMarkdownPrice,
  getShouldShowMinimumPriceMessage,
  isCanonicalProduct
} from '../../../../shared/utils/product/product';

import { ProductData } from '../../../../shared/types/graphql-types';

import './product-list-card-price.scss';

interface ProductListCardPriceProps {
  hideInstantPromo?: boolean;
  isStaggered?: boolean;
  product: ProductData;
  quantity: number;
  totalQuantity: number;
}

function ProductListCardPrice(props: ProductListCardPriceProps) {
  const { hideInstantPromo = false, product, quantity, totalQuantity } = props;

  const { selectedFitment } = useFitment();
  const { isLoggedIn } = useMyAccount();

  if (!product) return null;

  const { mapDisplayRule, unitName } = product;
  const isCanonical = isCanonicalProduct(product);
  const priceInfo = getPriceInfo(product);

  const { instantMapSavingsPerProduct = 0 } = getMapProductInstantSavingsInfo(
    product,
    isLoggedIn,
    quantity
  );
  const mapShowMinimumPriceMessage =
    process.env.__FF_MAP_PRICE_STRIKE_THROUGH__ === 'true' &&
    instantMapSavingsPerProduct
      ? !isLoggedIn
      : true;
  const showMinimumPriceMessage =
    mapShowMinimumPriceMessage && getShouldShowMinimumPriceMessage(product);

  const showMarkdownPrice = getShouldShowMarkdownPrice(product, totalQuantity);

  return (
    <div styleName="container">
      {showMarkdownPrice && (
        <StackedMarkdownPrice
          hideInstantPromo={hideInstantPromo}
          product={product}
          totalQuantity={totalQuantity}
        />
      )}
      <Price
        instantPromotionOriginalRetailValue={
          priceInfo?.instantPromotionOriginalRetailValue
        }
        mapPrice={priceInfo?.mapPrice}
        price={priceInfo?.price}
        priceRange={priceInfo?.priceRange}
        styleName="price"
        totalQuantity={totalQuantity}
        unitName={unitName}
        variant="H3"
      />

      {showMinimumPriceMessage && (
        <MinimumPriceMessage message={mapDisplayRule?.message} />
      )}

      {isCanonical && (
        <Typography size="small" styleName="exact-price-msg" tag="div">
          {selectedFitment ? (
            'View product details for exact price & inventory'
          ) : (
            <>
              <Link size="small" to="#/fitment/vehicle">
                enter vehicle
              </Link>{' '}
              for exact price & inventory
            </>
          )}
        </Typography>
      )}
    </div>
  );
}

export default ProductListCardPrice;
